var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Container, Dialog, Styler, Stacker, TypographyBody } from '@honeycomb/ui-core';
import { TripType, useGlobalContext, useSearch } from '@honeycomb/data';
import { BrandLogo } from '../../../components/Brand/BrandLogo';
import { useTimeout } from '../../../utils';
import { HotelProgressBar } from './HotelInterstitialProgressBar';
import { InterstitialUSPs } from './InterstitialUSPs';
const LOADING_SCREEN_DURATION = 500;
export function HotelInterstitial(_a) {
    var { progressBarComplete } = _a, dialogProps = __rest(_a, ["progressBarComplete"]);
    const { resourceStrings: { HC_HOLIDAY_CONTINUE_INTERSTITIAL_DYNAMIC_MESSAGES, HC_HOTEL_CONTINUE_INTERSTITIAL_DYNAMIC_MESSAGES, HC_CONTINUE_INTERSTITIAL_STATIC_MESSAGE, }, configSettings: { HcRoomConfirmAverageTimeHoliday, HcRoomConfirmAverageTimeHotel }, } = useGlobalContext();
    const [searchState] = useSearch([]);
    const [loading, setLoading] = useState(true);
    const messages = searchState.tripType === TripType.Holiday
        ? HC_HOLIDAY_CONTINUE_INTERSTITIAL_DYNAMIC_MESSAGES
        : HC_HOTEL_CONTINUE_INTERSTITIAL_DYNAMIC_MESSAGES;
    const messagesArr = messages.split(':');
    const totalDuration = searchState.tripType === TripType.Hotel
        ? parseInt(HcRoomConfirmAverageTimeHotel)
        : parseInt(HcRoomConfirmAverageTimeHoliday);
    const progressBarDuration = totalDuration - LOADING_SCREEN_DURATION;
    /* loading screen for {x}ms */
    const { restartTimer } = useTimeout(LOADING_SCREEN_DURATION, () => {
        setLoading(false);
    });
    if (loading && dialogProps.open) {
        restartTimer();
    }
    return (React.createElement(Dialog, Object.assign({ fullScreen: "always", position: "centered", loading: loading, dismissable: false, withAnimation: false }, dialogProps),
        React.createElement(Styler, { bg: "background.offset", h: "100%", display: "flex", alignItems: "center" },
            React.createElement(Container, { maxWidth: "l" },
                React.createElement(Stacker, { display: "flex", alignItems: "center" },
                    React.createElement(Styler, { mb: 4 },
                        React.createElement(BrandLogo, null)),
                    React.createElement(HotelProgressBar, { messages: messagesArr, totalDuration: progressBarDuration, progressBarComplete: progressBarComplete }),
                    React.createElement(Stacker, { spacing: { xs: 8, m: 12 }, alignItems: "center", alignSelf: "stretch" },
                        React.createElement(TypographyBody, { size: "s", mt: 4 }, HC_CONTINUE_INTERSTITIAL_STATIC_MESSAGE),
                        React.createElement(InterstitialUSPs, null)))))));
}
